module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_04_sp-a4397ee2d6cdfb39cbcfab7825a2ae55.png";